import { Section } from "./Section";
import { PROBLEM } from "@/content/landing";

export function Problem() {
  return (
    <Section
      id="problem"
      testId="landing-problem"
      eyebrow={PROBLEM.eyebrow}
      title={PROBLEM.title}
      subtitle={PROBLEM.intro}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {PROBLEM.pillars.map((p, i) => (
          <article
            key={i}
            data-testid={`landing-problem-card-${i}`}
            className="group relative overflow-hidden rounded-2xl border border-border/60 bg-card/60 p-7 transition-colors hover:border-accent/50"
          >
            <div className="flex items-baseline gap-3">
              <span className="font-mono text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
                {p.stat}
              </span>
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent">
                fact
              </span>
            </div>
            <h3 className="mt-3 text-base font-semibold text-foreground sm:text-lg">
              {p.label}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              {p.body}
            </p>
            <div className="pointer-events-none absolute -bottom-px left-7 right-7 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
          </article>
        ))}
      </div>
    </Section>
  );
}
